"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

var debug           = require("debug")("models:AggregationModel");    //https://github.com/visionmedia/debug

// AggregationModel
module.exports = Backbone.Model.extend({
  
    defaults: {
        name:null,
        queryModel:null,
        agg:null         // result aggregation from elastic, multiple form ...
    },

    initialize: function (attributes, options) {
        debug("initialize");
        _.extend(this, options);    

    }

});